import { decorators } from '@sohohouse/platform-resources'

const { DateTime } = decorators.shared

export default (cancellableUntil, $t, $d) => {
  if (cancellableUntil) {
    const cancelDateTime = new DateTime(cancellableUntil)
    if (cancelDateTime.inPast) {
      return $t('STAY_BOOKED_CANCELLATION_NO_REFUND_SUPPORTING')
    }
    const time = $d(cancelDateTime.withOffset.epoch, 'time')
    const date = $d(cancelDateTime.withOffset.epoch, 'shortDate')
    return $t('STAY_ROOM_CANCELLATION_HOURS_SUPPORTING', { time, date })
  }
  return $t('STAY_ROOM_CANCELLATION_NO_REFUND_SUPPORTING')
}

